import React from 'react';
import ErrorHexegon from '@elliemae/ds-icons/ErrorHexegon';
import WarningTriangle from '@elliemae/ds-icons/WarningTriangle';
import CheckmarkCircle from '@elliemae/ds-icons/CheckmarkCircle';
import HelpCircle from '@elliemae/ds-icons/HelpCircle';
import InfoCircle from '@elliemae/ds-icons/InfoCircle';
import { MODAL_SUB_TYPE_V2 } from '../../constants.js';
import { ModalFeedback } from '../blocks.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

var feedbackIconSize = 'xxl';

var getIconType = function getIconType(subtype) {
  switch (subtype) {
    case MODAL_SUB_TYPE_V2.WARNING:
      return /*#__PURE__*/React.createElement(WarningTriangle, {
        "data-testid": "icon-waring",
        size: feedbackIconSize
      });

    case MODAL_SUB_TYPE_V2.ERROR:
      return /*#__PURE__*/React.createElement(ErrorHexegon, {
        "data-testid": "icon-error",
        size: feedbackIconSize
      });

    case MODAL_SUB_TYPE_V2.SUCCESS:
      return /*#__PURE__*/React.createElement(CheckmarkCircle, {
        "data-testid": "icon-success",
        size: feedbackIconSize
      });

    case MODAL_SUB_TYPE_V2.INFORMATION:
      return /*#__PURE__*/React.createElement(InfoCircle, {
        "data-testid": "icon-information",
        size: feedbackIconSize
      });

    default:
      return /*#__PURE__*/React.createElement(HelpCircle, {
        "data-testid": "icon-help",
        size: feedbackIconSize
      });
  }
};

var FeedbackIcon = function FeedbackIcon(_ref) {
  var modalSubType = _ref.modalSubType;
  return /*#__PURE__*/React.createElement(ModalFeedback, {
    classProps: {
      type: modalSubType
    }
  }, getIconType(modalSubType));
};

export default FeedbackIcon;
export { FeedbackIcon };
//# sourceMappingURL=FeedbackIcon.js.map
